import type { FProject, FUser } from "../profile";

export type UniqueDocIdentifier = {
  userId: FUser["id"];
  projectId: FProject["id"];
  id: string;
};

/**
 * Domains help assign tags and categories to
 * different parts of the application.
 *
 * This allows different tags to be used in different contexts
 */
export type Domain =
  | {
      name: "Blog";
      id: "blog";
    }
  | {
      name: "Artifact";
      id: "artifact";
    };

export type BaseDescriptor = {
  name: string;
  id: string;
};

export interface Tag extends BaseDescriptor {
  metadata?: {
    color?: string | null;
  };
}

export interface Category extends BaseDescriptor {
  metadata?: {
    color?: string | null;
  };
}

/* -------------------------------------------------------------------------- */
/*                             FIREBASE STRUCTURE                             */
/* -------------------------------------------------------------------------- */

export enum DescriptorType {
  CATEGORY = "category",
  TAG = "tag",
}

export type FCategories = UniqueDocIdentifier & {
  type: DescriptorType.CATEGORY;
  domainId: Domain["id"];
  categories: Category[];
};

export type FTags = UniqueDocIdentifier & {
  type: DescriptorType.TAG;
  domainId: Domain["id"];
  tags: Tag[];
};

export type FDescriptor = FCategories | FTags;
